import { render, staticRenderFns } from "./ZyTable.vue?vue&type=template&id=07b7d21e"
import script from "./ZyTable.vue?vue&type=script&lang=js"
export * from "./ZyTable.vue?vue&type=script&lang=js"
import style0 from "./ZyTable.vue?vue&type=style&index=0&id=07b7d21e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports